"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Menu.default;
  }
});

var _Menu = _interopRequireDefault(require("./Menu"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Menu/index.js
// module id = 429
// module chunks = 0